import React from 'react'
import packageJson from '../../../package.json'
import styles from './styles.module.css'
import { Box, Link as MuiLink, Typography } from '@mui/material'
import { useTheme, alpha } from '@mui/material/styles'

function Footer() {
	const theme = useTheme()
	const containerBg =
		theme.palette.mode === 'dark' ? alpha(theme.palette.background.default, 0.9) : theme.palette.background.default
	const textColor = theme.palette.text.secondary
	const borderColor = theme.palette.divider

	return (
		<Box
			className={styles.container}
			sx={{
				backgroundColor: containerBg,
				borderTopColor: borderColor,
				color: textColor,
			}}
		>
			<Typography variant="body2" component="p" sx={{ m: 0 }}>
				Developed by{' '}
				<MuiLink
					className={styles.itzCoding}
					href="https://itzcoding.com"
					target="_blank"
					rel="noopener noreferrer"
					sx={{ color: '#0e9f9e', fontWeight: 600 }}
				>
					itzCoding
				</MuiLink>{' '}
				for AlReaaya.
			</Typography>
		</Box>
	)
}

export default Footer
